import breadcrumbs from "@/views/modules/ExpressionInterests/MenuList.vue";
import lang from "@/views/modules/ExpressionInterests/language/en";
import Editor from '@tinymce/tinymce-vue';
import Datepicker from 'vuejs-datepicker';
import tinymce from 'vue-tinymce-text-editor';
import vSelect from "vue-select";
import loader from "@/views/shared/loading/Loading.vue";
import alert from "@/views/shared/notify/Alert.vue";
import SelectFile from "@/components/layout/shared/generic/common/SelectFile.vue";

export default {
    name: "edit-opportunity",
   
    components: {
        breadcrumbs,
        'editor': Editor,
        Datepicker,
        loader,
        vSelect,
        'tinymce': tinymce,
        alert,
        SelectFile
    },
    data() {
        return {
            loading: true,
            deleteProductModal: false,
            dataList: {},
            lang:[],
            showEdit:false,
            edit:true,
            close:false,
            title:false,
            relatedLinksList: [],
            related_link: {},
            submittedDate:'',
            commentsList: [],
            activitiesList: [],
            activitiesListitems: [],
            customLoading:'',
            comment: '',
            usersList: [],
            usersEmailList:[],
            taggedUser: [],
            current_url:'',
            reminder: {
                users: []
            },
            remindersList: [],
            am:'AM',
            pm:'PM',
            dom_array: [],
        }
    },
    mounted() {
        this.getProduct();
        this.loadRelatedLinks();
        
        this.dom_array = this.domArrayVariable;
        this.lang = lang;
        this.current_url = window.app.app_url;
        let userInfo = localStorage.getItem('user_prefrence');
                let userData = (JSON.parse(userInfo));
                let timeFormat = userData.timeformat.split(":");
                if(timeFormat[1][1] == 'a')
                {
                    this.am = 'am';
                    this.pm = 'pm';
                }if(timeFormat[1][1] == 'A')
                {
                    this.am = 'AM';
                    this.pm = 'PM';
                }
    },
    computed: {
        hours() {
            return Array.from({ length: 12 }, (_, index) => (index + 1).toString().padStart(2, '0'));
        },
        minutes() {
            return Array.from({ length: 60 }, (_, minute) => minute.toString().padStart(2, '0'));
        }
    },
    methods: {
       
        getProduct() {
            const self = this;
            self.loading = true;
             window.currentAction = 'view';
                axios.get('api/modules/exinterests/' + self.$route.params.id).then(function (response) {
                self.dataList = response.data;
                self.submittedDate = self.dataList.submited_on;
                self.loading = false;
                self.title = true;
                self.getUserList();
            }).catch(function () {
                self.loading = false;
            });
        },
        deleteProduct() {
            const self = this;
            axios.delete('api/dashboard/modules/products/' + self.$route.params.id).then(function () {
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data deleted successfully').toString(),
                    type: 'success'
                });
                self.$router.push('/modules/products');
            }).catch(function () {
                self.loading = false;
                self.deleteProductModal = false;
            });
        },

        editEnable(chk){
            const self = this;
            if(chk == 'edit'){
                self.showEdit = true;
                self.edit = false;
                self.close = true;
            }else{
                self.updateColumn();
            }
            
        },
        updateColumn(){
            const self = this;
            let eoi_note = document.getElementById("eoi_note").value;
            let submited_on = '';
            if(document.getElementById("submited_on").value == '')
            {
                submited_on = self.submittedDate;
            }else{
                submited_on = document.getElementById("submited_on").value;
            }
            
            let eoi_status = document.getElementById("status").value;
            let formData = {
                'eoi_id': self.$route.params.id,
                'eoi_note':eoi_note,
                'status':eoi_status,
                'submited_on':submited_on,
                'upload_file':self.dataList.upload_file,
                'upload_file_name':self.dataList.upload_file_name,
            }
            
            axios.post('api/modules/exinterests/update_exinterest', formData).then(function (response) {
                self.showEdit = false;
                self.edit = true;
                self.close = false;
                self.getProduct();
            }).catch(function () {
                self.loading = false;
                self.process = false;
                let allerror = document.getElementsByClassName('error');
                        for(let i = 0; i < allerror.length; i++)
                        {
                            allerror[i].innerHTML = '';
                        }
                        let err = localStorage.getItem('Errors');
                        let err_msg = (JSON.parse(err));
                        let err_msg2 = err_msg && err_msg.errors ? err_msg.errors : {};
                        Object.keys(err_msg2 || {}).forEach((key) => {
                            let errorval = err_msg2[key];
                           
                            let error_el = document.getElementById(key+"_error");
                                error_el.innerHTML = errorval
                        });
                        localStorage.removeItem('Errors');
            });
        },
        addRelatedLink() {
            const self = this;
            let formData = {
                'parent_type': 'Exinterests',
                'parent_id': self.$route.params.id,
                'name': self.related_link.title,
                'description': self.related_link.link,
            }
            if (self.related_link.link === '' || self.related_link.tile === '') {
               
                self.$refs.notifyMsg.showAlert('Error', 'link & title can not be empty');
                return false;
            }

            self.customLoading = 'addRelatedLink';
            axios.post('api/modules/relatedLinks', { editFormData: formData }).then(function (response) {
                self.related_link = {};
                $("#relativeLinkModal").modal("hide");
                self.loadRelatedLinks();
                self.customLoading = false;
            })
        },
        loadRelatedLinks() {
            const self = this;
            let searches = {
                parent_type: {
                    key: 'parent_type',
                    value: 'Exinterests'
                },
                parent_id: {
                    key: 'parent_id',
                    value: self.$route.params.id
                }
            }
            self.customLoading = 'relatedLink';
             
                axios.get('api/modules/relatedLinks', { params: { search: searches } }).then(function (response) {
                self.relatedLinksList = response.data.items;
                self.customLoading = false;
            })
        },
        isAbsoluteURL(url) {
            return /^(https?:\/\/)|^(\/\/)/.test(url);
        },
        customFormatter(date) {
            return moment(date).format('DD/MM/yyyy');
        },

        loadComments() {
            const self = this;
            let searches = {
                'parent_type': 'ExInterests',
                'parent_id': self.$route.params.id,
            }
            self.customLoading = 'comment';
             window.currentAction = 'list';
                axios.get('api/modules/comments', { params: { search: searches, perPage: '999999999999' } }).then(function (response) {
                self.commentsList = response.data.items.reverse();
                self.customLoading = false;
            })
        },
        loadActivities() {
            const self = this;
            let searches = {
                'parent_type': 'ExInterests',
                'parent_id': self.$route.params.id,
            }
            self.customLoading = 'activity';
             window.currentAction = 'list';
                axios.get('api/modules/comments', { params: { search: searches, perPage: '999999999999' } }).then(function (response) {
                var activitiesListData = {};
                const activitiesListitems = response.data.items;
                activitiesListitems.forEach(entry => {
                    const date = self.extractDate(entry.date_entered);
                    if (activitiesListData[date]) {
                        activitiesListData[date].push(entry);
                    } else {
                        activitiesListData[date] = [entry];
                    }
                });
                self.customLoading = false;
                self.activitiesList = activitiesListData;
            })
        },
        extractDate(dateString) {
            const dateObj = moment(dateString, 'DD/MM/YYYY h:mma');
            const formattedDate = dateObj.format('DD/MM/YYYY');
            return formattedDate;
        },
        getUserList() {
            const self = this;
            window.currentAction = 'detail';
            axios.post('api/modules/users/select').then(function (response) {

                self.usersList = response.data.items.map(item => ({
                    id: item.id,
                    dname: item.display_name || `${item.name} (${item.email})`,
                    // Same "Full Name (email)" label the Opportunity reminder shows.
                    name: item.display_name || `${item.name} (${item.email})`,
                }));

                self.usersEmailList = response.data.items.map(item => ({
                    id: item.id,
                    uemail: item.display_name || `${item.name} (${item.email})`,
                    email: item.email,
                }));
            })
        },
        addComments() {
            const self = this;
            let formData = {
                'parent_type': 'ExInterests',
                'parent_id': self.$route.params.id,
                'description': self.comment,
                'taggedUser': self.taggedUser,
            }
            // Check if taggedUser array is empty
            if (self.taggedUser.length === 0) {
                self.$refs.notifyMsg.showAlert('Error', 'Please select at least one tag user first.');
                return false;
            }
            if (self.comment === '') {
                
                self.$refs.notifyMsg.showAlert('Error', 'comment can not be empty');
                return false;
            }
            
            self.customLoading = 'addComment';
            axios.post('api/modules/comments', formData).then(function (response) {
                self.loadComments();
                self.comment = '';
                self.taggedUser = [];
                document.getElementById("comment").value = '';
                self.customLoading = false;
            })
        },
        formatTime(hours, minutes, period) {
            let formattedTime = ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2) + ':00';
            formattedTime += period === 'am' ? 'AM' : 'PM';
            return formattedTime;
        },
        saveReminder() {
            const errorMessages = document.getElementsByClassName('error-message');
            while (errorMessages.length > 0) {
                errorMessages[0].remove();
            }
            const self = this;
            self.customLoading = 'reminder';
            self.reminder.parent_type = 'ExInterests';
            self.reminder.parent_id = self.$route.params.id;
            self.reminder.reminder_time = self.formatTime(self.reminder.hours, self.reminder.minutes, self.reminder.period);
            axios.post('api/modules/reminders', self.reminder).then(function (response) {
                self.customLoading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data saved correctly').toString(),
                    type: 'success'
                });
                self.reminder = {};
                self.loadReminders();
                // self.reminder.users = [];
            }).catch(function (response) {
                self.customLoading = false;

                let err = localStorage.getItem('Errors');
                let err_msg = (JSON.parse(err));
                let err_msg2 = err_msg.errors;
                Object.keys(err_msg2).forEach((key) => {
                    let errorval = err_msg2[key];
                    const input = document.getElementById(key);
                    const errorDiv = document.createElement('span');
                    errorDiv.className = 'error-message error';
                    errorDiv.textContent = errorval;
                    input.insertAdjacentHTML('afterend', errorDiv.outerHTML);
                });
                localStorage.removeItem('Errors');
            });
        },
        loadReminders() {
            const self = this;
            let searches = {
                parent_type: {
                    key: 'parent_type',
                    value: 'ExInterests',
                },
                parent_id: {
                    key: 'parent_id',
                    value: self.$route.params.id
                }
            }
            self.customLoading = 'reminder';
             window.currentAction = 'list';
                axios.get('api/modules/reminders', { params: { search: searches } }).then(function (response) {
                self.remindersList = response.data.items;
                self.customLoading = false;
            })
        },
        deleteReminder(recordId) {
            const self = this;
            self.customLoading = 'reminder';
            const deleteRecord = { 'delete_id': recordId };
            axios.post('api/modules/reminders/remove', deleteRecord).then(function () {
                self.customLoading = false;
                self.loadReminders();
            }).catch(function(){
                self.customLoading = false;
            });
        },
        removeBR(str){
            return str.replace(/<br\s*\/?>/gi, '\n')
        },
        downloadPrivate(doc_id, tbl,filename) {
            const self = this;
            const token = localStorage.getItem('token');
            if (!token) {
                alert('Please login to download files');
                return;
            }
            
            axios.get(`api/modules/download/${doc_id}/${tbl}`, {
                responseType: 'blob',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((response) => {
                //console.log(response);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            }).catch((error) => {
                console.error('Download failed:', error);
                self.$refs.notifyMsg.showAlert('Error', 'Download failed. File may not exist or access denied.');
            });
        }
    }
}